module.exports = __webpack_public_path__ + "static/recoverforlife-14a9afeee4d208be808ee5c8f6964d10.png";